import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const DEFAULTS = {
  announcement_on: false,
  accepting_leads: true,
  phone: "",
  email: "",
  whatsapp: "",
  address: "",
  services_enabled: ["banking", "payments", "bbps", "insurance", "travel", "essential", "credit"],
  stats: [],
};

const SiteCtx = createContext({ settings: DEFAULTS, testimonials: [], gallery: [], districtCounts: {} });

export const SiteProvider = ({ children }) => {
  const [data, setData] = useState({ settings: DEFAULTS, testimonials: [], gallery: [], districtCounts: {} });
  useEffect(() => {
    api
      .get("/site")
      .then((r) => {
        setData({
          settings: { ...DEFAULTS, ...(r.data?.settings ?? {}) },
          testimonials: Array.isArray(r.data?.testimonials) ? r.data.testimonials : [],
          gallery: Array.isArray(r.data?.gallery) ? r.data.gallery : [],
          districtCounts: r.data?.district_counts && typeof r.data.district_counts === "object" ? r.data.district_counts : {},
        });
      })
      .catch(() => {});
  }, []);
  return <SiteCtx.Provider value={data}>{children}</SiteCtx.Provider>;
};

export const useSite = () => useContext(SiteCtx);
